import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function PromotionsPage() {
  const [activeTab, setActiveTab] = useState<'welcome' | 'ongoing' | 'referral' | 'vip'>('welcome');

  const bonusTiers = [
    {
      deposit: '$30+',
      bonus: '20% Bonus',
      spins: '0 FS',
      total: 'Up to $36',
      highlight: false
    },
    {
      deposit: '$100+',
      bonus: '30% Bonus',
      spins: '50 FS',
      total: 'Up to $130',
      highlight: false
    },
    {
      deposit: '$300+',
      bonus: '50% Bonus',
      spins: '100 FS',
      total: 'Up to $450',
      highlight: true
    }
  ];

  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Instant Bonus Credit',
      desc: 'Bonus credited immediately after first deposit'
    },
    {
      icon: 'ri-gamepad-line',
      title: 'Play Like Real Money',
      desc: 'Use bonus funds on any game you want'
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Withdrawable Winnings',
      desc: 'All winnings from bonus play are withdrawable'
    },
    {
      icon: 'ri-gift-line',
      title: 'Extra Free Spins',
      desc: 'Additional free spins on top of bonus'
    }
  ];

  const rules = [
    {
      title: 'Eligibility',
      items: [
        'Available only for new users within 30 days of registration',
        'One-time offer per account, household, and IP address',
        'Must be 18+ years old to participate'
      ]
    },
    {
      title: 'Bonus Terms',
      items: [
        'Minimum deposit: $30 to qualify for bonus',
        'Maximum bonus: $150 + 100 Free Spins',
        'Bonus is automatically credited after deposit',
        'Wagering requirement: 35x bonus amount'
      ]
    },
    {
      title: 'Free Spins',
      items: [
        'Free spins valid on selected slot games only',
        'Each spin valued at $0.10',
        'Free spins expire 7 days after credit',
        'Winnings from free spins subject to 35x wagering'
      ]
    },
    {
      title: 'Withdrawal',
      items: [
        'Complete wagering requirements before withdrawal',
        'Maximum withdrawal from bonus: $5,000',
        'Standard verification process applies',
        'Withdrawal cancels any remaining bonus balance'
      ]
    },
    {
      title: 'General Rules',
      items: [
        'Promotion can be modified or terminated at any time',
        'DIGITWISE reserves the right to void bonuses in case of abuse',
        'Standard Terms & Conditions apply',
        'Responsible gaming limits still apply to bonus play'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Header />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] text-white overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-[#FFD349] rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#FF9800] rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FFD349]/20 to-[#FF9800]/20 border border-[#FFD349]/30 rounded-full px-6 py-2 mb-6">
            <i className="ri-vip-crown-line text-2xl text-[#FFD349]"></i>
            <span className="text-sm font-semibold text-[#FFD349]">NEW USER EXCLUSIVE</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-black mb-6 leading-tight">
            First Deposit Gets You<br />
            <span className="bg-gradient-to-r from-[#FFD349] via-[#FFC107] to-[#FF9800] bg-clip-text text-transparent">
              Up to $150 Instant Bonus
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-4 font-semibold">
            + 100 Free Spins 🎉
          </p>
          
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-300 mb-8">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-[#FFD349]"></i>
              <span>Instant bonus credit after deposit</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-[#FFD349]"></i>
              <span>Winnings are withdrawable</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-[#FFD349]"></i>
              <span>Valid for 30 days after registration</span>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/signup"
              className="group relative px-8 py-4 bg-gradient-to-r from-[#FFD349] via-[#FFC107] to-[#FF9800] text-black font-bold text-lg rounded-full hover:shadow-2xl hover:shadow-[#FFD349]/50 transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              <span className="relative z-10 flex items-center gap-2">
                Claim Your Bonus Now 💰
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </Link>
            
            <button
              onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold text-lg rounded-full hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
            >
              How It Works
            </button>
          </div>
          
          <div className="mt-8 inline-flex items-center gap-2 text-sm text-[#FFD349]">
            <i className="ri-time-line"></i>
            <span className="font-semibold">Limited Time Offer — Don't Miss Out! 🔥</span>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-1 py-1 overflow-x-auto scrollbar-hide">
            <button
              onClick={() => setActiveTab('welcome')}
              className={`flex-1 min-w-fit px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap ${
                activeTab === 'welcome'
                  ? 'bg-gradient-to-r from-[#FFD349] to-[#FF9800] text-black shadow-lg'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <i className="ri-gift-line mr-2"></i>
              Welcome Bonus
            </button>
            <button
              onClick={() => setActiveTab('referral')}
              className={`flex-1 min-w-fit px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap ${
                activeTab === 'referral'
                  ? 'bg-gradient-to-r from-[#FFD349] to-[#FF9800] text-black shadow-lg'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <i className="ri-team-line mr-2"></i>
              Refer a Friend
            </button>
            <button
              onClick={() => setActiveTab('ongoing')}
              className={`flex-1 min-w-fit px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap ${
                activeTab === 'ongoing'
                  ? 'bg-gradient-to-r from-[#FFD349] to-[#FF9800] text-black shadow-lg'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <i className="ri-calendar-line mr-2"></i>
              Ongoing Promotions
            </button>
            <button
              onClick={() => setActiveTab('vip')}
              className={`flex-1 min-w-fit px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap ${
                activeTab === 'vip'
                  ? 'bg-gradient-to-r from-[#FFD349] to-[#FF9800] text-black shadow-lg'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <i className="ri-vip-crown-line mr-2"></i>
              VIP Rewards
            </button>
          </div>
        </div>
      </div>

      {/* Welcome Bonus Content */}
      {activeTab === 'welcome' && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {/* Bonus Tiers */}
          <div id="how-it-works" className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-black text-gray-900 mb-4">
                Choose Your Bonus Tier
              </h2>
              <p className="text-lg text-gray-600">
                The more you deposit, the bigger your bonus! 🎁
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {bonusTiers.map((tier, index) => (
                <div
                  key={index}
                  className={`relative rounded-2xl p-8 transition-all duration-300 hover:scale-105 ${
                    tier.highlight
                      ? 'bg-gradient-to-br from-[#FFD349] via-[#FFC107] to-[#FF9800] text-black shadow-2xl'
                      : 'bg-white border-2 border-gray-200 hover:border-[#FFD349]'
                  }`}
                >
                  {tier.highlight && (
                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-black text-[#FFD349] px-6 py-2 rounded-full text-sm font-bold whitespace-nowrap">
                      🔥 MOST POPULAR
                    </div>
                  )}
                  
                  <div className="text-center">
                    <div className={`text-5xl font-black mb-2 ${tier.highlight ? 'text-black' : 'text-gray-900'}`}>
                      {tier.deposit}
                    </div>
                    <div className={`text-sm mb-6 ${tier.highlight ? 'text-black/70' : 'text-gray-500'}`}>
                      First Deposit
                    </div>
                    
                    <div className="space-y-3 mb-6">
                      <div className={`flex items-center justify-between py-3 border-b ${
                        tier.highlight ? 'border-black/20' : 'border-gray-200'
                      }`}>
                        <span className={tier.highlight ? 'text-black/80' : 'text-gray-600'}>Bonus</span>
                        <span className="font-bold text-lg">{tier.bonus}</span>
                      </div>
                      <div className={`flex items-center justify-between py-3 border-b ${
                        tier.highlight ? 'border-black/20' : 'border-gray-200'
                      }`}>
                        <span className={tier.highlight ? 'text-black/80' : 'text-gray-600'}>Free Spins</span>
                        <span className="font-bold text-lg">{tier.spins}</span>
                      </div>
                      <div className={`flex items-center justify-between py-3 ${
                        tier.highlight ? 'border-black/20' : ''
                      }`}>
                        <span className={tier.highlight ? 'text-black/80' : 'text-gray-600'}>Total Value</span>
                        <span className="font-black text-2xl">{tier.total}</span>
                      </div>
                    </div>
                    
                    <Link
                      to="/signup"
                      className={`block w-full py-4 rounded-full font-bold transition-all duration-300 whitespace-nowrap ${
                        tier.highlight
                          ? 'bg-black text-[#FFD349] hover:bg-gray-900'
                          : 'bg-gradient-to-r from-[#FFD349] to-[#FF9800] text-black hover:shadow-lg'
                      }`}
                    >
                      Claim This Bonus
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-8 text-sm text-gray-500">
              ⭐ Bonus is automatically applied after your first deposit
            </div>
          </div>

          {/* Why Participate */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-black text-gray-900 mb-4">
                Why Should You Participate?
              </h2>
              <p className="text-lg text-gray-600">
                Start your journey with better conditions than others! 🚀
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-6 border-2 border-gray-200 hover:border-[#FFD349] transition-all duration-300 hover:shadow-lg"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-[#FFD349] to-[#FF9800] rounded-2xl flex items-center justify-center mb-4">
                    <i className={`${benefit.icon} text-3xl text-black`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600">
                    {benefit.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-black text-gray-900 mb-4">
                Terms & Conditions
              </h2>
              <p className="text-lg text-gray-600">
                Please read carefully before participating
              </p>
            </div>

            <div className="space-y-6">
              {rules.map((section, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 border-2 border-gray-200"
                >
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <span className="w-8 h-8 bg-gradient-to-br from-[#FFD349] to-[#FF9800] rounded-full flex items-center justify-center text-black text-sm font-black">
                      {index + 1}
                    </span>
                    {section.title}
                  </h3>
                  <ul className="space-y-3">
                    {section.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="flex items-start gap-3 text-gray-700">
                        <i className="ri-checkbox-circle-fill text-[#FFD349] text-xl mt-0.5 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* FOMO CTA */}
          <div className="bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] rounded-3xl p-12 text-center text-white relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-0 w-64 h-64 bg-[#FFD349] rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#FF9800] rounded-full blur-3xl"></div>
            </div>
            
            <div className="relative z-10">
              <h2 className="text-4xl font-black mb-4">
                Don't Regret Missing Out! 🔥
              </h2>
              <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                This is your only chance to get these exclusive benefits.<br />
                Start now and get ahead of everyone else!
              </p>
              
              <Link
                to="/signup"
                className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-[#FFD349] via-[#FFC107] to-[#FF9800] text-black font-black text-xl rounded-full hover:shadow-2xl hover:shadow-[#FFD349]/50 transition-all duration-300 hover:scale-105 whitespace-nowrap"
              >
                Claim Instant $150 Bonus Now 👑
                <i className="ri-arrow-right-line"></i>
              </Link>
              
              <div className="mt-6 text-sm text-gray-400">
                ⏰ Offer expires 30 days after registration
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Referral Program Content */}
      {activeTab === 'referral' && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FFD349]/20 to-[#FF9800]/20 border border-[#FFD349]/30 rounded-full px-6 py-2 mb-6">
              <i className="ri-team-line text-2xl text-[#FFD349]"></i>
              <span className="text-sm font-semibold text-[#FFD349]">REFERRAL REWARDS</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
              🧑‍🤝‍🧑 Refer a Friend Rewards Program
            </h1>
            
            <p className="text-2xl text-gray-700 font-bold mb-4">
              🎉 Invite Friends & Earn Bonuses!
            </p>
            
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              When your invited friend completes their first deposit,<br />
              both the referrer and the new friend receive rewards!
            </p>
          </div>

          {/* Rewards Overview */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {/* Referrer Benefits */}
            <div className="bg-gradient-to-br from-[#FFD349] via-[#FFC107] to-[#FF9800] rounded-3xl p-8 text-black shadow-2xl">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-16 h-16 bg-black/10 rounded-2xl flex items-center justify-center">
                  <i className="ri-user-star-line text-4xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-black">👤 Referrer Benefits</h3>
                  <p className="text-black/70 font-semibold">(Existing User)</p>
                </div>
              </div>

              <div className="space-y-4 mb-6">
                <div className="bg-black/10 rounded-2xl p-6">
                  <p className="text-sm text-black/70 mb-2">Per Friend's First Deposit</p>
                  <p className="text-4xl font-black mb-1">$10 Bonus</p>
                  <p className="text-sm font-bold">Instant Credit 💰</p>
                </div>

                <div className="bg-black/10 rounded-2xl p-6">
                  <p className="text-sm text-black/70 mb-2">Maximum Referrals</p>
                  <p className="text-4xl font-black mb-1">Up to 10 Friends</p>
                  <p className="text-sm font-bold">Earn up to $100 in Rewards 🎁</p>
                </div>
              </div>
            </div>

            {/* Friend Benefits */}
            <div className="bg-white border-2 border-[#FFD349] rounded-3xl p-8 shadow-xl">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-[#FFD349] to-[#FF9800] rounded-2xl flex items-center justify-center">
                  <i className="ri-user-add-line text-4xl text-black"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-black text-gray-900">🆕 Referred Friend Benefits</h3>
                  <p className="text-gray-600 font-semibold">New User Rewards</p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6 mb-4">
                <p className="text-center text-lg font-bold text-gray-900 mb-2">
                  Extra Bonus on First Deposit
                </p>
                <p className="text-center text-sm text-gray-600">
                  Tiered rewards based on deposit amount
                </p>
              </div>

              <div className="space-y-3">
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                  <span className="font-bold text-gray-900">$30~$99</span>
                  <span className="text-[#FFD349] font-bold">20% Bonus</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                  <span className="font-bold text-gray-900">$100~$299</span>
                  <span className="text-[#FFD349] font-bold">30% + 50 FS</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-gradient-to-r from-[#FFD349]/20 to-[#FF9800]/20 rounded-xl border-2 border-[#FFD349]">
                  <span className="font-bold text-gray-900">$300+</span>
                  <span className="text-[#FF9800] font-black">50% + 100 FS</span>
                </div>
              </div>

              <div className="mt-6 space-y-2 text-sm text-gray-600">
                <p className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-[#FFD349]"></i>
                  💰 Bonus credited instantly to your account
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-[#FFD349]"></i>
                  🎁 Free spins available on selected slot games
                </p>
              </div>
            </div>
          </div>

          {/* How It Works */}
          <div className="mb-16">
            <h2 className="text-4xl font-black text-gray-900 text-center mb-12">
              🔗 How to Refer
            </h2>

            <div className="grid md:grid-cols-4 gap-6">
              {[
                {
                  step: '1',
                  icon: 'ri-links-line',
                  title: 'Copy Link',
                  desc: 'Go to My Page → Click "Copy Referral Link"'
                },
                {
                  step: '2',
                  icon: 'ri-share-forward-line',
                  title: 'Share with Friends',
                  desc: 'Send the link to your friends'
                },
                {
                  step: '3',
                  icon: 'ri-user-add-line',
                  title: 'Auto Connection',
                  desc: 'Friend signs up → Automatically linked'
                },
                {
                  step: '4',
                  icon: 'ri-gift-line',
                  title: 'Get Rewards',
                  desc: 'Friend deposits → Rewards auto-credited 🎁'
                }
              ].map((item, index) => (
                <div key={index} className="relative">
                  <div className="bg-white border-2 border-gray-200 rounded-2xl p-6 hover:border-[#FFD349] transition-all duration-300 hover:shadow-lg">
                    <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-[#FFD349] to-[#FF9800] rounded-full flex items-center justify-center text-black font-black text-xl shadow-lg">
                      {item.step}
                    </div>
                    
                    <div className="w-16 h-16 bg-gradient-to-br from-[#FFD349]/20 to-[#FF9800]/20 rounded-2xl flex items-center justify-center mb-4 mt-4">
                      <i className={`${item.icon} text-4xl text-[#FF9800]`}></i>
                    </div>
                    
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      {item.desc}
                    </p>
                  </div>
                  
                  {index < 3 && (
                    <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                      <i className="ri-arrow-right-line text-3xl text-[#FFD349]"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="mb-16">
            <h2 className="text-4xl font-black text-gray-900 text-center mb-12">
              📌 Reward Conditions
            </h2>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white border-2 border-gray-200 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                  <i className="ri-checkbox-circle-line text-[#FFD349] text-3xl"></i>
                  Eligibility Requirements
                </h3>
                <ul className="space-y-4">
                  {[
                    'Friend must complete their first deposit',
                    'Accounts from the same device are not eligible',
                    'Repeated sign-ups from same IP will be excluded',
                    'Bonus must be wagered before withdrawal'
                  ].map((item, index) => (
                    <li key={index} className="flex items-start gap-3 text-gray-700">
                      <i className="ri-check-line text-[#FFD349] text-xl mt-0.5 flex-shrink-0"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                  <i className="ri-shield-check-line text-[#FFD349] text-3xl"></i>
                  Bonus Policy
                </h3>
                <ul className="space-y-4">
                  {[
                    'Priority use on slot games',
                    'Multiple accounts for event abuse will be restricted',
                    'Fraudulent activity may result in bonus forfeiture',
                    'Verification system applied for safe gameplay'
                  ].map((item, index) => (
                    <li key={index} className="flex items-start gap-3 text-gray-700">
                      <i className="ri-lock-line text-[#FFD349] text-xl mt-0.5 flex-shrink-0"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Special Bonus */}
          <div className="bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] rounded-3xl p-12 text-white relative overflow-hidden mb-16">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-0 w-64 h-64 bg-[#FFD349] rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#FF9800] rounded-full blur-3xl"></div>
            </div>
            
            <div className="relative z-10 text-center">
              <h2 className="text-4xl font-black mb-6">
                🌟 Special Event
              </h2>
              
              <div className="max-w-3xl mx-auto space-y-6">
                <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8">
                  <p className="text-2xl font-bold mb-3">
                    Refer 5 Friends Successfully
                  </p>
                  <p className="text-3xl font-black text-[#FFD349] mb-2">
                    👉 Unlock Special Bonus Package
                  </p>
                  <p className="text-sm text-gray-300">
                    (Subject to admin policy)
                  </p>
                </div>

                <div className="bg-gradient-to-r from-[#FFD349]/20 to-[#FF9800]/20 border border-[#FFD349]/30 rounded-2xl p-6">
                  <p className="text-xl font-bold">
                    More referrals = Faster VIP level progression 👑
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-br from-[#FFD349] via-[#FFC107] to-[#FF9800] rounded-3xl p-12 text-center text-black shadow-2xl">
            <h2 className="text-4xl font-black mb-6">
              🎯 Start Referring Now!
            </h2>
            
            <div className="grid md:grid-cols-3 gap-6 mb-8 max-w-4xl mx-auto">
              {[
                { icon: 'ri-links-line', text: 'Copy My Referral Link' },
                { icon: 'ri-share-forward-line', text: 'Share with Friends' },
                { icon: 'ri-gift-line', text: 'Friend Deposits → Instant Bonus' }
              ].map((item, index) => (
                <div key={index} className="bg-black/10 rounded-2xl p-6">
                  <i className={`${item.icon} text-4xl mb-3 block`}></i>
                  <p className="font-bold">{item.text}</p>
                </div>
              ))}
            </div>

            <p className="text-2xl font-black mb-8">
              👉 Easiest way to earn rewards for both you and your friends!
            </p>

            <Link
              to="/profile"
              className="inline-flex items-center gap-3 px-10 py-5 bg-black text-[#FFD349] font-black text-xl rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
            >
              Get My Referral Link
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      )}

      {/* Ongoing Promotions */}
      {activeTab === 'ongoing' && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center py-20">
            <i className="ri-calendar-check-line text-6xl text-gray-300 mb-4"></i>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              More Promotions Coming Soon!
            </h2>
            <p className="text-lg text-gray-600">
              Stay tuned for exciting ongoing promotions and special events.
            </p>
          </div>
        </div>
      )}

      {/* VIP Rewards */}
      {activeTab === 'vip' && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center py-20">
            <i className="ri-vip-crown-line text-6xl text-[#FFD349] mb-4"></i>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Exclusive VIP Rewards
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Unlock premium benefits as you level up your VIP status.
            </p>
            <Link
              to="/vip"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-[#FFD349] to-[#FF9800] text-black font-bold text-lg rounded-full hover:shadow-lg transition-all duration-300 whitespace-nowrap"
            >
              View VIP Program
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
